
import axios from 'axios'
import { failimg } from '@/assets/timg.jpg'
import wx from 'weixin-js-sdk'
import { getConfig } from '@/api/wx.js'
import { getintegral, operateCreditlist } from '@/api/user.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import config from '@/config'
import Scroll from '@/components/scroller'
import { Field, Popover, Button, ActionSheet } from 'vant'
import {
getList,
getList1,
getList2,
addLiked,
deleteLiked,
addCredit,
deleteMoments,
stickie,
unstickie,
addComment,
deleteComment,
commentTip,
complaintlist
} from '@/api/yuangongquan'
export default {
directives: {
TransferDom
},
components: { XDialog, Popup, Scroll, Swiper, SwiperItem, Tab, TabItem, vanField: Field, vanPopover: Popover, vanButton: Button, vanActionSheet: ActionSheet },
data () {
return {
failimg: failimg,
tabActive: 0,
baseUrl: config.baseUrl,
pageSize: 10,
pageCurrent: 1,
owner_type: config.owner_type,
list: [],
showmenu1: false,
showDialog: false,
dialogObj: {},
creditList: [5, 10, 15, 20, 25, 30],
credit: 5,
currentCreditIndex: 0,
currentObj: {},
currentIndex: 0,
integral: 0, // 总积分
notFirstLoad: false,
loadMoreDom: null,
listDom: null,
showcomment: false, // 弹出评论
commentObj: {}, // 评论列表
commentIndex: 0,
commentText: '',
sendtext: '',
loop: '',
reportObj: '',
showreport: false,
reportlist: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
isAdmin () {

return this.$store.state.user.personObj.isAdmin
}
},
beforeRouteEnter (to, from, next) {
if (from.name !== 'yuangongquanDetail') {
to.meta.isUseCache = false
}
next()
},
watch: {
commentText: function (val) {
let temp = val.replace(/^\s*/, '')
this.sendtext = temp
}
},
activated () {
if (!this.$route.meta.isUseCache) {
this.tabActive = 0
this.pageCurrent = 1
this.wxconfig()
this.getList()
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
config.scrollPosition.y = 0
}
this.listDom.scrollTop = config.scrollPosition.y
},
mounted () {
this.getreporttype()
},
methods: {
getreporttype () {
axios.get('https://www.zjftu.org/youzheng/sysDd/FTU_productComplaint_TYPE.action').then(data => {
this.reportlist = data.data
})
},
showreportlist (item, index) {
this.reportObj = item
this.showreport = true
},
report (type) {
this.showreport = false
commentTip({
commentid: this.reportObj.id,
accountid: this.accountid,
type: type
}).then(res => {
if (res.success) {
this.$vux.toast.text('举报成功!')
}
})
},
start (event, item, index) {
event.preventDefault()
this.$refs.comment[index].style.backgroundColor = '#bdbebe'
console.log()
clearTimeout(this.loop) 

this.loop = setTimeout(() => {
if (!item.isnew) {
item.showpopover = true
}
}, 600)
},
end (item, index) {
this.$refs.comment[index].style.backgroundColor = ''
clearTimeout(this.loop) 
},
onSelect (item, index) {
deleteComment({
id: item.id
}).then(res => {
if (res.success) {
this.$vux.toast.text(res.msg)
item.showpopover = false
item.isdelete = true
}
})
},
comment (item, index) {
this.commentObj = item
this.commentIndex = index
this.showcomment = true
},
submit () {
if (this.sendtext.length == 0) {
return false
}
addComment({
momentid: this.commentObj.id,
accountid: this.accountid,
comment: this.sendtext
}).then(res => {
if (res.success) {
this.$vux.toast.text(res.msg)
this.showcomment = false
console.log(this.$store.state.user.personObj.iconimgPATH)
this.list[this.commentIndex].plList.unshift(
{
'filepath': this.$store.state.user.personObj.iconimgPATH,
'acctname': this.$store.state.user.personObj.acctname,
'createdate': '刚刚',
'comment': this.sendtext,
'isdelete': false,
'showpopover': false,
'isnew': true
}
)
}
})
},

onItemClick (index) {
if (this.tabActive !== index) {
this.listDom.scrollTop = 0
this.pageCurrent = 1
this.tabActive = index
this.getList()
}
},
getList (type, done) {
let method = ''
if (this.tabActive === 0) {
method = getList1 
} else if (this.tabActive === 1) {
method = getList2
} else if (this.tabActive === 2) {
method = getList
}
method({
pageSize: this.pageSize,
pageCurrent: this.pageCurrent,
myuserid: this.userid
})
.then(res => {
if (res.success) {
if (type === 'refresh') {
this.list = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.obj
obj.forEach(el => {
if (el.plList.length > 0) {
this.$set(el.plList, 'showpopover', 'false')
this.$set(el.plList, 'isdelete', 'false')
this.$set(el.plList, 'isnew', 'false')
}
})
if (obj.length === 0 && this.pageCurrent === 1) {
this.list = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
this.list = this.pageCurrent === 1 ? obj : [...this.list, ...obj]
if (this.pageSize > res.obj.length) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
this.$nextTick(() => {
this.list.forEach((el, index) => {
let descHeight = window.getComputedStyle(this.$refs.desc[index]).height.replace('px', '')
if (descHeight > 44) {
this.$set(this.list[index], 'showmore', false)
this.$set(this.list[index], 'showmoreButton', true)
this.$set(this.list[index], 'showTotal', true)
} else {
this.$set(this.list[index], 'showmore', false)
this.$set(this.list[index], 'showmoreButton', false)
this.$set(this.list[index], 'showTotal', false)
}
})
})
}
})
.catch(() => {
this.notFirstLoad = true
done && done()
})
},
showmore (val, index) {
if (val) {
this.$set(this.list[index], 'showmore', false)
this.$set(this.list[index], 'showTotal', true)
} else {
this.$set(this.list[index], 'showmore', true)
this.$set(this.list[index], 'showTotal', false)
}
},

zan (obj, index) {
if (obj.mlike === '1') {
deleteLiked({
momentsid: obj.id,
userid: this.userid
}).then(res => {
let cnum =
this.list[index].cnum === '' ? 0 : parseInt(this.list[index].cnum)
this.$set(this.list[index], 'cnum', cnum - 1)
this.$set(this.list[index], 'mlike', '')
this.$vux.toast.text('取消点赞')
})
} else {
addLiked({
userid: this.userid,
uargetid: obj.userid,
momentsid: obj.id
}).then(res => {
let cnum =
this.list[index].cnum === '' ? 0 : parseInt(this.list[index].cnum)
this.$set(this.list[index], 'cnum', cnum + 1)
this.$set(this.list[index], 'mlike', '1')
this.$vux.toast.text('点赞成功')

operateCreditlist({
accountid: this.accountid,
rulecode: 'interact',
credit: 1,
owner_type: config.owner_type,
terminaltype: 2
})
})
}
},

shang (obj, index) {








},

addCredit () {
































},
showpopup1 (obj, index) {
this.currentObj = obj
this.currentIndex = index
this.showmenu1 = true
},

gotoCheck () {
this.$router.push({
name: 'yuangongquanReport',
params: { id: this.currentObj.id }
})
},

onDelete () {
let _this = this
this.$vux.confirm.show({
title: '提示信息',
content: '确定要删除吗？',
onConfirm () {
deleteMoments({
id: _this.currentObj.id
}).then(res => {
_this.showmenu1 = false
_this.$vux.toast.text('删除成功')
_this.$delete(_this.list, _this.currentIndex)
})
}
})
},

onStickie () {
stickie({
id: this.currentObj.id
}).then(res => {
this.showmenu1 = false
this.$vux.toast.text(res.msg)
this.pageCurrent = 1
this.getList()
})
},
onUnStickie () {
unstickie({
id: this.currentObj.id
}).then(res => {
this.showmenu1 = false
this.$vux.toast.text('取消置顶成功')
this.pageCurrent = 1
this.getList()
})
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
},

refresh (done) {
this.pageCurrent = 1
this.loadMoreDom.innerText = '加载中...'
this.getList('refresh', done)
},

loadMore (done) {
this.pageCurrent++
this.loadMoreDom.innerText = '加载中...'
this.getList('more', done)
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['previewImage'] 
})
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item.FILEPATH)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
gotoDetail (obj) {
if (obj.userid === this.userid) {
this.$router.push({ name: 'yuangongquanMy', params: { id: obj.userid } })
} else {
this.$router.push({ name: 'yuangongquanUserlist', params: { id: obj.userid } })
}
},
detail (id) {
config.scrollPosition.y = this.listDom.scrollTop
this.$router.push({ name: 'yuangongquanDetail', params: { id: id } })
}
}
}
